<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.application') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.create")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <!-- Start progress workflow -->
                    <div v-if="!user.data.is_officer" class="col-md-12 col-sm-12">
                        <div class="callout callout-success">
                            <br>
                            <workflow-process />
                        </div>
                    </div>
                    <!-- End progress workflow // -->

                    <div class="col-md-12 col-sm-12">
                        <!-- Start Customs Registration -->
                        <div class="card card-default" id="customs-info">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title required"><fa :icon="['fas', 'door-open']"></fa> {{ $t("label.customs_registration") }}<span class="text-danger"> * </span></h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.customs ? $t('label.expand') : $t('label.collapse')" @click="collapse.customs = !collapse.customs">
                                        <fa :icon="collapse.customs ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="register_type" class="col-md-4 col-form-label required">{{$t('label.register_type')}}</label>
                                    <div class="col-md-8">
                                        <select name="register_type" v-validate="'required'" class="form-control" id="register_type" v-model="declaration.registration_type">
                                            <option value="IM" style="padding-bottom : 10px; padding-top: 0px; margin-bottom: 10px;">{{$t('label.temporary_import')}}</option>
                                            <option value="EX" style="padding-bottom : 10px; padding-top: 0px; margin-bottom: 10px;">{{$t('label.temporary_export')}}</option>
                                        </select>
                                        <span v-if="errors.has('register_type')" class="text-danger">
                                            {{ errors.first('register_type') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="registration_number" class="col-md-4 col-form-label required">{{$t('label.register_number')}}</label>
                                    <div class="col-md-8">
                                        <input name="registration_number" id="registration_number" type="text" class="form-control" :placeholder="$t('label.register_number')" v-model="declaration.registration_number" readonly disabled tabindex="-1" />
                                        <span v-if="errors.has('registration_number')" class="text-danger">
                                            {{ errors.first('registration_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type!=='EX' ? $t('label.entry_office_name') : $t('label.exit_office_name')}}</label>
                                    <div class="col-md-8">
                                        <v-select
                                                v-model="lodgement_office"
                                                v-validate="'required'"
                                                :name="declaration.registration_type!=='EX' ? 'entry_office_name' : 'exit_office_name'"
                                                :key="declaration.registration_type!=='EX' ? 'has_type' : 'no_type'"
                                                id="lodgement_office_name"
                                                :options="offices"
                                                label="full_name"
                                                @input="clearLodgmentOffice">
                                        </v-select>
                                        <span v-if="errors.has('entry_office_name')" class="text-danger">
                                            {{ errors.first('entry_office_name') }}
                                        </span>
                                        <span v-if="errors.has('exit_office_name')" class="text-danger">
                                            {{ errors.first('exit_office_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type!=='EX' ? $t('label.entry_date') : $t('label.exit_date')}}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                                v-model="declaration.lodgement_office_date"
                                                v-validate="'required'"
                                                :key="declaration.registration_type!=='EX' ? 'has_lodgement_office_date' : 'no_lodgement_office_date'"
                                                :name="declaration.registration_type!=='EX' ? 'entry_date' : 'exit_date'"
                                                :id="declaration.registration_type!=='EX' ? 'entry_date' : 'exit_date'"
                                                v-on:selected="changeEntryDate"
                                                :bootstrapStyling="true"
                                                :clearButton="true"
                                                :highlighted="highlightedCurrentDate"
                                                :language="lang"
                                                input-class="form-control form-control-datepicker"
                                                format="dd/MM/yyyy"
                                                :placeholder="'DD/MM/YYYY'"
                                                :disabledDates="{ to: new Date(Date.now()-24*60*60*1000) }">
                                        </datepicker>
                                        <span v-if="errors.has('entry_date')" class="text-danger">
                                            {{ errors.first('entry_date') }}
                                        </span>
                                        <span v-if="errors.has('exit_date')" class="text-danger">
                                            {{ errors.first('exit_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="destination_office" class="col-md-4 col-form-label required">{{ declaration.registration_type==='EX' ? $t('label.entry_office_name') : $t('label.exit_office_name')}}</label>
                                    <div class="col-md-8">
                                        <v-select
                                                v-model="destination_office"
                                                v-validate="'required'"
                                                :key="declaration.registration_type==='EX' ? 'has_destination_office' : 'no_destination_office'"
                                                :name="declaration.registration_type==='EX' ? 'destination_entry_office_name' : 'destination_exit_office_name'"
                                                id="destination_office"
                                                :options="offices"
                                                label="full_name"
                                                @input="clearDestinationOffice">

                                        </v-select>
                                        <span v-if="errors.has('destination_entry_office_name')" class="text-danger">
                                            {{ errors.first('destination_entry_office_name') }}
                                        </span>
                                        <span v-if="errors.has('destination_exit_office_name')" class="text-danger">
                                            {{ errors.first('destination_exit_office_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type==='EX' ? $t('label.entry_date') : $t('label.exit_date')}}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                                v-model="declaration.destination_office_date"
                                                v-validate="'required'"
                                                :name="declaration.registration_type==='EX' ? 'destination_entry_date' : 'destination_exit_date'"
                                                :key="declaration.registration_type==='EX' ? 'has_destination_entry_date' : 'has_destination_entry_date'"
                                                id="exit_date"
                                                v-on:selected="changeExitDate"
                                                :disabledDates="{ to: new Date(declaration.lodgement_office_date), from: new Date(allow_max_period) }"
                                                :bootstrapStyling="true"
                                                :clearButton="true"
                                                :highlighted="highlightedCurrentDate"
                                                :language="lang"
                                                input-class="form-control form-control-datepicker"
                                                format="dd/MM/yyyy"
                                                :placeholder="'DD/MM/YYYY'">
                                        </datepicker>
                                        <span v-if="errors.has('destination_entry_date')" class="text-danger">
                                            {{ errors.first('destination_entry_date') }}
                                        </span>
                                        <span v-if="errors.has('destination_exit_date')" class="text-danger">
                                            {{ errors.first('destination_exit_date') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Owner information -->
                        <div class="card card-default" id="owner-info">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title required"><fa :icon="['fas', 'user']"></fa> {{ $t('label.owner_information') }}<span class="text-danger"> * </span></h3>
                                <div class="card-tools">
                                  <button v-if="user.data.is_officer" type="button" class="btn btn-tool text-primary" @click="ownerList">
                                    {{ $isMobile() ? $t('label.choose') : $t('label.choose_owner')}}
                                    <fa :icon="fas.faUserAlt" class="ml-1"/>
                                  </button>
                                    <button :disabled="user.data.is_officer && !declaration.owner.first_name" type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.owner ? $t('label.expand') : $t('label.collapse')" @click="collapse.owner = !collapse.owner">
                                        <fa :icon="collapse.owner ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body" v-if="isOwnerExpandable">
                                <div v-if="!user.data.is_officer" class="form-group row">
                                    <label class="col-md-4 col-form-label" style="margin-top: -5px;">{{$t('label.owner_confirm') }}</label>
                                    <div class="col-md-8">
                                        <span>{{$t('label.no')}} </span>
                                        <label class="switch">
                                            <input type="checkbox" v-model="declaration.is_owner" @change="isOwner">
                                            <span class="slider round"></span>
                                        </label>
                                        <span> {{$t('label.yes')}}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.last_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" name="last_name" id="last_name" class="form-control" :placeholder="$t('label.last_name')" v-model="declaration.owner.last_name" v-validate="{required : !declaration.is_owner }" :disabled="declaration.is_owner || is_officer"/>
                                        <span v-if="errors.has('last_name')" class="text-danger">
                                            {{ errors.first('last_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.first_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" name="first_name" id="first_name" class="form-control" :placeholder="$t('label.first_name')" v-model="declaration.owner.first_name" v-validate="{required : !declaration.is_owner }" :disabled="declaration.is_owner || is_officer"/>
                                        <span v-if="errors.has('first_name')" class="text-danger">
                                            {{ errors.first('first_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.nationality') }}</label>
                                    <div class="col-md-8">
                                        <v-select
                                            v-show="!declaration.is_owner && !is_officer"
                                            v-model="declaration.owner.nationality"
                                            name="nationality"
                                            id="nationality"
                                            v-validate="{required : !declaration.is_owner }"
                                            :options="countryNames"
                                        >
                                        </v-select>
                                        <input v-show="declaration.is_owner || is_officer" type="text" name="nationality" class="form-control" v-model="declaration.owner.nationality"  :disabled="true">
                                        <span v-if="errors.has('nationality')" class="text-danger">
                                            {{ errors.first('nationality') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.gender') }}</label>
                                    <div class="col-md-8">
                                        <select class="form-control" name="gender" id="gender" v-model="declaration.owner.gender" v-validate="{required : !declaration.is_owner }" :disabled="declaration.is_owner || is_officer">
                                            <option value="m">{{ $t('label.male') }}</option>
                                            <option value="f">{{ $t('label.female') }}</option>
                                        </select>
                                        <span v-if="errors.has('gender')" class="text-danger">
                                            {{ errors.first('gender') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="owner_passport_number" class="col-md-4 col-form-label">{{ $t('label.passport_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text"
                                            v-validate="{required : !declaration.is_owner}"
                                            name="owner_passport_number"
                                            id="owner_passport_number"
                                            class="form-control"
                                            :placeholder="$t('label.passport_number')"
                                            v-model="declaration.owner.passport_number"
                                            :disabled="is_officer"
                                        />
                                        <span v-if="errors.has('owner_passport_number')" class="text-danger">
                                            {{ errors.first('owner_passport_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_issued_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-show="!is_officer"
                                            v-validate="{required : !declaration.is_owner}"
                                            name="passport_issued_date"
                                            id="passport_issued_date"
                                            v-model="declaration.owner.passport_issued_date"
                                            :bootstrap-styling="true"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :clear-button="!declaration.is_owner"
                                            :input-class="declaration.is_owner ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'"
                                            :disabled="is_officer"
                                        >
                                        </datepicker>
                                        <input v-show="is_officer" type="text" class="form-control" v-model="declaration.owner.passport_issued_date" :placeholder="$t('label.passport_issued_date')" :disabled="true">
                                        <span v-if="errors.has('passport_issued_date')" class="text-danger">
                                            {{ errors.first('passport_issued_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_expired_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-show="!is_officer"
                                            v-validate="{required : !declaration.is_owner}"
                                            name="passport_expired_date"
                                            id="passport_expired_date"
                                            v-model="declaration.owner.passport_expired_date"
                                            :bootstrap-styling="true"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :clear-button="!declaration.is_owner"
                                            :input-class="declaration.is_owner ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'"
                                            :disabled="is_officer"
                                        >
                                        </datepicker>
                                        <input v-show="is_officer" type="text" class="form-control" v-model="declaration.owner.passport_expired_date" :placeholder="$t('label.passport_expired_date')" :disabled="true">
                                        <span v-if="errors.has('passport_expired_date')" class="text-danger">
                                            {{ errors.first('passport_expired_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="owner_border_pass_number" class="col-md-4 col-form-label">{{ $t('label.border_pass_number') }}</label>
                                    <div class="col-md-8">
                                        <input
                                            v-validate="{required : !(declaration.owner.passport_number && declaration.owner.passport_issued_date && declaration.owner.passport_expired_date) }"
                                            :key="'owner_border_pass_number'"
                                            name="owner_border_pass_number"
                                            id="owner_border_pass_number"
                                            type="text"
                                            class="form-control"
                                            :placeholder="$t('label.border_pass_number')"
                                            v-model="declaration.owner.border_pass_number"
                                            :disabled="is_officer"
                                        />
                                        <span v-if="errors.has('owner_border_pass_number')" class="text-danger">
                                            {{ errors.first('owner_border_pass_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.border_pass_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-show="!is_officer"
                                            v-model="declaration.owner.border_pass_date"
                                            v-validate="{required : !(declaration.owner.passport_number && declaration.owner.passport_issued_date && declaration.owner.passport_expired_date) }"
                                            name="owner_border_pass_date"
                                            :bootstrap-styling="true"
                                            :clear-button="true"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            input-class="form-control form-control-datepicker can-editable"
                                            key="has_owner_border_pass_date">
                                        </datepicker>
                                        <input v-show="is_officer" type="text" name="owner_border_pass_date" class="form-control" v-model="declaration.owner.border_pass_date" :placeholder="$t('label.border_pass_date')" :disabled="true">
                                        <span v-if="errors.has('owner_border_pass_date')" class="text-danger">
                                            {{ errors.first('owner_border_pass_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_number') }} <span class="text-danger">  </span></label>
                                    <div class="col-md-8">
                                        <input type="text" name="identity_number" id="identity_number" v-model="declaration.owner.identity_card_number" class="form-control" :placeholder="$t('label.identity_number')" v-validate="{required : false}" :disabled="declaration.is_owner || is_officer"/>
                                        <span v-if="errors.has('identity_number')" class="text-danger">
                                            {{ errors.first('identity_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_date') }} <span class="text-danger">  </span></label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-show="!is_officer"
                                            name="identity_date"
                                            id="identity_date"
                                            v-model="declaration.owner.identity_card_issued_date"
                                            :bootstrap-styling="true"
                                            v-validate="{required : false }"
                                            :disabled="declaration.is_owner"
                                            :clear-button="!declaration.is_owner"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="declaration.is_owner ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        >
                                        </datepicker>
                                        <input v-show="is_officer" type="text" name="identity_date" class="form-control" v-model="declaration.owner.identity_card_issued_date" :disabled="true">
                                        <span v-if="errors.has('identity_date')" class="text-danger">
                                            {{ errors.first('identity_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }} <span class="text-danger">  </span></label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-show="!is_officer"
                                            name="identity_date_expire"
                                            id="identity_date_expire"
                                            v-model="declaration.owner.identity_card_expired_date"
                                            :bootstrap-styling="true"
                                            v-validate="{required : false }"
                                            :disabled="declaration.is_owner"
                                            :clear-button="!declaration.is_owner"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="declaration.is_owner ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        >
                                        </datepicker>
                                        <input v-show="is_officer" type="text" name="identity_date_expire" class="form-control" v-model="declaration.owner.identity_card_expired_date" :disabled="true">
                                        <span v-if="errors.has('identity_date_expire')" class="text-danger">
                                            {{ errors.first('identity_date_expire') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="address_in_cambodia" class="col-md-4 col-lg-4 col-form-label">{{ $t('label.address_in_cambodia') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8 col-lg-8">
                                    <!-- <textarea name="address_in_cambodia" id="address_in_cambodia" type="text" class="form-control" placeholder="address ..." v-model="declaration.owner.address"  v-validate="{required : !declaration.is_owner }" :disabled="declaration.is_owner" rows="3"></textarea> -->
                                        <textarea name="address_in_cambodia" id="address_in_cambodia" type="text" class="form-control" placeholder="address ..." v-model="declaration.owner.address"  v-validate="{required : !declaration.is_owner }" rows="3"></textarea>
                                        <span v-if="errors.has('address_in_cambodia')" class="text-danger">
                                            {{ errors.first('address_in_cambodia')}}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.length_of_stay') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.length_of_stay')" v-model="declaration.owner.inbound_stay" :disabled="true"/>
                                    </div>
                                </div>

                                <div style="text-align:right;" v-if="canViewOwner && declaration.owner.uuid">
                                  <a href="#" @click.prevent="viewOwnerDetail" :title="$t('label.view_detail')">{{ $t('label.view_detail') }}</a>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Vehicle information -->
                        <div class="card card-default" id="vehicle-info">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'car']"></fa> {{ $t('label.vehicle_information') }} <span class="text-danger"> * </span></h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool text-primary" @click="vehicleList">
                                        {{ $isMobile() ? $t('label.choose') : $t('label.choose_vehicle') }}
                                        <fa :icon="fas.faCarAlt" class="ml-1"/>
                                    </button>
                                    <button :disabled="declaration.vehicles.length === 0" type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.vehicle ? $t('label.expand') : $t('label.collapse')" @click="collapse.vehicle = !collapse.vehicle">
                                        <fa :icon="collapse.vehicle || declaration.vehicles.length === 0 ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body mb-0" v-if="declaration.vehicles.length > 0">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.plate_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].plate_number" class="form-control" :placeholder="$t('label.plate_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.nationality') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].nationality" class="form-control" :placeholder="$t('label.nationality')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.type') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].type_name" class="form-control" :placeholder="$t('label.type')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.brand') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].brand" class="form-control" :placeholder="$t('label.brand')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.steer') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].steer" class="form-control" :placeholder="$t('label.steer')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.color') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].color" class="form-control" :placeholder="$t('label.color')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.frame_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].frame_number" class="form-control frame_number" :placeholder="$t('label.frame_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.engine_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].engine_number" class="form-control engine_number" :placeholder="$t('label.engine_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.year') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="number" v-model="declaration.vehicles[0].year" class="form-control" :placeholder="$t('label.year')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>

                                <div style="text-align:right;" v-if="canViewVehicle">
                                    <a href="#"  @click.prevent="viewVehicleDetail" :title="$t('label.view_detail')">{{ $t('label.view_detail') }}</a>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Driver information -->
                        <div class="card card-default" id="driver-info">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'users']"></fa> {{ $t('label.driver_information') }} <span class="text-danger"> * </span></h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool text-primary" @click="driverList">
                                        {{ $isMobile() ? $t('label.choose') : $t('label.choose_driver') }}
                                        <fa :icon="fas.faUser" class="ml-1"/>
                                    </button>
                                    <button :disabled="declaration.drivers.length === 0" type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.driver ? $t('label.expand') : $t('label.collapse')" @click="collapse.driver = !collapse.driver">
                                        <fa :icon="collapse.driver || declaration.drivers.length === 0 ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                   <!-- <button :disabled="user.data.is_officer && !isDriverExpandable" type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.driver ? $t('label.expand') : $t('label.collapse')" @click="collapse.driver = !collapse.driver">
                                        <fa :icon="collapse.driver ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button> -->
                                </div>
                            </div>
                        <!--<div class="card-body mb-0" v-if="isDriverExpandable">
                              <div v-if="!user.data.is_officer" class="form-group row">
                                  <label class="col-md-4 col-form-label">{{$t('label.owner_also_driver') }}</label>
                                  <div class="col-md-8">
                                      <span>{{$t('label.no')}} </span>
                                      <label class="switch">
                                          <input type="checkbox" v-model="owner_is_driver" @change="ownerAlsoDriver">
                                          <span class="slider round"></span>
                                      </label>
                                      <span> {{$t('label.yes')}}</span>
                                  </div>
                            </div>-->
                            <div class="card-body mb-0" v-if="declaration.drivers.length > 0">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.last_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" name="driver_last_name" v-validate="{required : true }" v-model="declaration.drivers[0].last_name" class="form-control" :placeholder="$t('label.last_name')" :disabled="owner_is_driver || is_officer" />
                                        <span v-if="errors.has('driver_last_name')" class="text-danger">{{ errors.first('driver_last_name')}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.first_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" name="driver_first_name" v-validate="{required : true }" v-model="declaration.drivers[0].first_name" class="form-control" :placeholder="$t('label.first_name')" :disabled="owner_is_driver || is_officer"  />
                                        <span v-if="errors.has('driver_first_name')" class="text-danger">{{ errors.first('driver_last_name')}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.gender') }}</label>
                                    <div class="col-md-8">
                                        <select class="form-control" name="driver_gender" id="driver_gender" v-validate="{required : true }" v-model="declaration.drivers[0].gender" :disabled="owner_is_driver || is_officer">
                                            <option value="m">{{ $t('label.male') }}</option>
                                            <option value="f">{{ $t('label.female') }}</option>
                                        </select>
                                        <span v-if="errors.has('driver_gender')" class="text-danger">{{ errors.first('driver_gender')}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ $t('label.nationality') }}</label>
                                    <div class="col-md-8">
                                        <v-select
                                            v-show="!owner_is_driver && !is_officer"
                                            v-model="declaration.drivers[0].nationality"
                                            name="driver_nationality"
                                            id="driver_nationality"
                                            v-validate="{required : true }"
                                            :options="countryNames"
                                            :disabled="owner_is_driver"
                                            @input="driverOfficeChange(declaration.drivers[0].nationality)"
                                        >
                                        </v-select>
                                        <input v-show="owner_is_driver || is_officer" type="text" class="form-control" v-model="declaration.drivers[0].nationality"  :disabled="true">
                                        <span v-if="errors.has('driver_nationality')" class="text-danger">{{ errors.first('driver_nationality')}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text"
                                               name="driver_identity_card_number"
                                               v-model="declaration.drivers[0].identity_card_number"
                                               v-validate="{required : isRequired(declaration.drivers[0], 'identity_number')}"
                                               class="form-control"
                                               :placeholder="$t('label.identity_number')"
                                               :disabled="owner_is_driver"/>
                                        <span v-if="errors.has('driver_identity_card_number')" class="text-danger">{{ errors.first('driver_identity_card_number')}}</span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="declaration.drivers[0].identity_card_issued_date"
                                            v-validate="{required : isRequired(declaration.drivers[0], 'identity_issued_date')}"
                                            :disabled="owner_is_driver"
                                            name="driver_identity_card_issued_date"
                                            :bootstrap-styling="true"
                                            :clear-button="!owner_is_driver"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="owner_is_driver ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        </datepicker>
                                        <span v-if="errors.has('driver_identity_card_issued_date')" class="text-danger">
                                            {{ errors.first('driver_identity_card_issued_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="declaration.drivers[0].identity_card_expired_date"
                                            v-validate="{required : isRequired(declaration.drivers[0], 'identity_expired_date')}"
                                            :disabled="owner_is_driver"
                                            name="driver_identity_card_expired_date"
                                            :bootstrap-styling="true"
                                            :clear-button="!owner_is_driver"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="owner_is_driver ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        </datepicker>
                                        <span v-if="errors.has('driver_identity_card_expired_date')" class="text-danger">
                                            {{ errors.first('driver_identity_card_expired_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label" :class="!(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date) ? 'required' : null">{{ $t('label.passport_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text"
                                               v-validate="{required : !(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date)}"
                                               v-model="declaration.drivers[0].passport_number"
                                               name="driver_passport_number"
                                               class="form-control"
                                               :placeholder="$t('label.passport_number')"
                                               :disabled="owner_is_driver"/>
                                        <span v-if="errors.has('driver_passport_number')" class="text-danger">
                                            {{ errors.first('driver_passport_number') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label" :class="!(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date) ? 'required' : null">{{ $t('label.passport_issued_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="declaration.drivers[0].passport_issued_date"
                                            v-validate="{required : !(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date)}"
                                            :disabled="owner_is_driver"
                                            name="driver_passport_issued_date"
                                            :bootstrap-styling="true"
                                            :clear-button="!owner_is_driver"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="owner_is_driver ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        </datepicker>
                                        <span v-if="errors.has('driver_passport_issued_date')" class="text-danger">
                                            {{ errors.first('driver_passport_issued_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label" :class="!(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date) ? 'required' : null">{{ $t('label.passport_expired_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="declaration.drivers[0].passport_expired_date"
                                            v-validate="{required : !(declaration.drivers[0].border_pass_number && declaration.drivers[0].border_pass_date)}"
                                            :disabled="owner_is_driver"
                                            name="driver_passport_expired_date"
                                            :bootstrap-styling="true"
                                            :clear-button="!owner_is_driver"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            :input-class="owner_is_driver ? 'form-control form-control-datepicker readonly': 'form-control form-control-datepicker can-editable'">
                                        </datepicker>
                                        <span v-if="errors.has('driver_passport_expired_date')" class="text-danger">
                                            {{ errors.first('driver_passport_expired_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label" :class="!(declaration.drivers[0].passport_number && declaration.drivers[0].passport_issued_date && declaration.drivers[0].passport_expired_date) ? 'required' : ''">{{ $t('label.border_pass_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text"
                                            v-validate="{ required : !(declaration.drivers[0].passport_number && declaration.drivers[0].passport_issued_date && declaration.drivers[0].passport_expired_date) }"
                                            v-model="declaration.drivers[0].border_pass_number"
                                            name="driver_border_pass_number"
                                            class="form-control"
                                            :placeholder="$t('label.border_pass_number')"
                                            :key="'has_driver_border_pass_number'"
                                        />
                                        <span v-if="errors.has('driver_border_pass_number')" class="text-danger">
                                            {{ errors.first('driver_border_pass_number') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label" :class="!(declaration.drivers[0].passport_number && declaration.drivers[0].passport_issued_date && declaration.drivers[0].passport_expired_date) ? 'required' : ''">{{ $t('label.border_pass_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                            v-model="declaration.drivers[0].border_pass_date"
                                            v-validate="{required : !(declaration.drivers[0].passport_number && declaration.drivers[0].passport_issued_date && declaration.drivers[0].passport_expired_date) }"
                                            name="driver_border_pass_date"
                                            :bootstrap-styling="true"
                                            :clear-button="true"
                                            :highlighted="highlightedCurrentDate"
                                            :language="lang"
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            input-class="form-control form-control-datepicker can-editable"
                                            key="has_driver_border_pass_date">
                                        </datepicker>

                                        <span v-if="errors.has('driver_border_pass_date')" class="text-danger">
                                            {{ errors.first('driver_border_pass_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="driver_address_in_cambodia" class="col-md-4 col-lg-4 col-form-label required">{{ $t('label.address_in_cambodia') }}</label>
                                    <div class="col-md-8 col-lg-8">
                                        <!-- <textarea
                                        v-validate="{required : true }"
                                        name="driver_address_in_cambodia"
                                        id="driver_address_in_cambodia"
                                        type="text"
                                        class="form-control"
                                        placeholder="address ..."
                                        v-model="declaration.drivers[0].address" :disabled="owner_is_driver" rows="3">
                                        </textarea> -->
                                        <textarea
                                            v-validate="{required : true }"
                                            name="driver_address_in_cambodia"
                                            id="driver_address_in_cambodia"
                                            type="text"
                                            class="form-control"
                                            placeholder="address ..."
                                            v-model="declaration.drivers[0].address" rows="3">
                                          </textarea>
                                        <span v-if="errors.has('driver_address_in_cambodia')" class="text-danger">
                                            {{ errors.first('driver_address_in_cambodia')}}
                                        </span>
                                    </div>
                                </div>
                                <div style="text-align:right;" v-if="canViewDriver && declaration.drivers[0].uuid">
                                    <a href="#"  @click.prevent="viewDriverDetail" :title="$t('label.view_detail')">{{ $t('label.view_detail') }}</a>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Company information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'hotel']"></fa> {{ $t('label.company_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.company ? $t('label.expand') : $t('label.collapse')" @click="collapse.company = !collapse.company">
                                        <fa :icon="collapse.company ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="company_code" class="col-md-4 col-form-label">{{ $t('label.company_code') }}</label>
                                    <div class="col-md-8">
                                        <input v-model="declaration.company_code" type="text" id="company_code" class="form-control" :placeholder="$t('label.company_code')" @blur="getCompany" @keydown="companyCodeKeyDown"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="company_name" class="col-md-4 col-form-label">{{ $t('label.company_name') }}</label>
                                    <div class="col-md-8">
                                        <input v-model="declaration.company_name" type="text" id="company_name" class="form-control" :placeholder="$t('label.company_name')" readonly disabled tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.company_address') }}</label>
                                    <div class="col-md-8">
                                        <textarea v-model="declaration.company_address" class="form-control" :placeholder="$t('label.company_address')" readonly disabled tabindex="-1" rows="3"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Guarantee information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'money-check-alt']"></fa> {{ $t('label.guarantee_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.guarantee ? $t('label.expand') : $t('label.collapse')" @click="collapse.guarantee = !collapse.guarantee">
                                        <fa :icon="collapse.guarantee ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="security_office" class="col-md-4 col-form-label">{{ $t('label.office')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_office"  v-validate="{ required: declaration.security_serial != '' && declaration.security_serial != null }" name="security_office" id="security_office" class="form-control" :placeholder="$t('label.office')" :class="security_errors.security_office ? 'error-border' : ''" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_office')" class="text-danger">{{ errors.first('security_office') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_serial" class="col-md-4 col-form-label">{{ $t('label.serial') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_serial" v-validate="{ required: declaration.security_number != '' && declaration.security_number != null }" name="security_serial" id="security_serial" class="form-control" :class="security_errors.security_serial ? 'error-border' : ''" :placeholder="$t('label.serial')" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_serial')" class="text-danger">{{ errors.first('security_serial') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_number" class="col-md-4 col-form-label">{{ $t('label.receipt_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_number" v-validate="{ required: declaration.security_date != '' && declaration.security_date != null }" name="security_number" id="security_number" class="form-control" :class="security_errors.security_number ? 'error-border' : ''" :placeholder="$t('label.receipt_number')" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_number')" class="text-danger">{{ errors.first('security_number') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.security_date" v-validate="{ required: declaration.security_office != '' && declaration.security_office != null }" name="security_date" :class="security_errors.security_date ? 'error-border' : ''" :bootstrap-styling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker" @input="getSecurityAmount"></datepicker>
                                        <span v-if="errors.has('security_date')" class="text-danger">{{ errors.first('security_date') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_amount" class="col-md-4 col-form-label">{{ $t('label.amount') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_amount" id="security_amount" class="form-control" :placeholder="$t('label.amount')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.currency')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_currency" class="form-control" :placeholder="$t('label.currency')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="mb-0" v-if="amount_is_returned">
                                    <br>
                                    <div class="alert alert-danger mb-0" role="alert">
                                        {{$t('label.security_returned')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Other information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'shield-alt']"></fa> {{ $t('label.other_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.other ? $t('label.expand') : $t('label.collapse')" @click="collapse.other = !collapse.other">
                                        <fa :icon="collapse.other ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="insurance_company_code" class="col-md-4 col-form-label">{{ $t('label.insurance_company_code') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_company_code" v-validate="{ required: declaration.insurance_date != '' && declaration.insurance_date != null }" name="insurance_company_code" id="insurance_company_code" class="form-control" :placeholder="$t('label.insurance_company_code')" @blur="getInsurance" />
                                        <span v-if="errors.has('insurance_company_code')" class="text-danger">
                                            {{ errors.first('insurance_company_code') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="insurance_company_name" class="col-md-4 col-form-label">{{ $t('label.insurance_company_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_company_name" v-validate="{ required: declaration.insurance_company_code != '' && declaration.insurance_company_code != null}" name="insurance_company_name" id="insurance_company_name" class="form-control" :placeholder="$t('label.insurance_company_name')" />
                                        <span v-if="errors.has('insurance_company_name')" class="text-danger">
                                            {{ errors.first('insurance_company_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="insurance_number" class="col-md-4 col-form-label">{{ $t('label.insurance_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_number" v-validate="{ required: declaration.insurance_company_name != '' && declaration.insurance_company_name != null }" name="insurance_number" id="insurance_number" class="form-control" :placeholder="$t('label.insurance_number')" />
                                        <span v-if="errors.has('insurance_number')" class="text-danger">
                                            {{ errors.first('insurance_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.insurance_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.insurance_date" v-validate="{ required: declaration.insurance_number != '' && declaration.insurance_number != null }" name="insurance_date" :bootstrapStyling="true" :highlighted="highlightedCurrentDate" :language="lang" :disabled="false" :clear-button="true" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'"></datepicker>
                                        <span v-if="errors.has('insurance_date')" class="text-danger">
                                            {{ errors.first('insurance_date') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-footer">
                                <input type="button" class="btn btn-primary float-right" @click.prevent="store" :value="$t('label.save')">
                            </div> -->
                        </div>
                        <!-- End // -->

                        <!-- Start Attachment file -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'paperclip']"></fa> {{ $t('label.attachment') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.attachment ? $t('label.expand') : $t('label.collapse')" @click="collapse.attachment = !collapse.attachment">
                                        <fa :icon="collapse.attachment ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.other') }}</label>
                                    <div class="col-md-8">

                                        <table class="table" v-if="files.length > 0">
                                            <tbody>
                                                <tr v-if="files.length" class="table-borderless">
                                                    <th>{{ $t('label.name') }}</th>
                                                    <th width="50px">{{ $t('label.delete') }}</th>
                                                </tr>
                                                <tr v-for="(file, index) in files" :key="index">
                                                    <td>
                                                        <span class="text-success cursor-pointer" @click="showImage(file)"
                                                        >{{ file.name.substring(file.name.length - 40 , file.name.length) }}
                                                        </span>
                                                    </td>
                                                    <td class="text-right">
                                                        <span class="btn btn-sm btn-link" @click="removeFile(index)"><fa :icon="fas.faTimesCircle" class="text-danger"/></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <a class="btn btn-sm btn-secondary" href="#" @click.prevent="$refs.attachment.click()">
                                                    <fa :icon="['fas', 'paperclip']"></fa>
                                                    {{$t('label.choose_document')}}
                                                </a>
                                                <input type="file" class="d-none" ref="attachment" name="attachment" id="attachment" accept="image/x-png,image/jpg,image/jpeg,application/pdf" multiple @change="handleFilesUpload">
                                            </div>
                                            <span class="text-muted ml-2 mt-2">{{ $t('label.other_file_criteria')}}</span>
                                        </div>

                                    </div>
                                </div>
                                 <input type="button" class="btn btn-primary float-right" @click.prevent="store" :value="$t('label.save')">
                            </div>
                        </div>
                        <!-- End // -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Start Vehicle list component -->
        <vehicle-list v-on:selectedVehicles="declaration.vehicles = $event; goIntoView('vehicle-info')" :selectedItems="declaration.vehicles" />
        <!-- End component // -->

        <!-- Start driver list component -->
        <driver-list v-on:selectedDrivers="declaration.drivers = $event; goIntoView('driver-info')" :selectedItems="declaration.drivers" />
        <!-- End // -->

        <!-- Start owner list component -->
        <owner-list v-on:selectedOwner="declaration.owner = $event; goIntoView('owner-info')"/>
        <!-- End // -->

        <!--  Modal Create Owner  -->
        <createOwnerModal/>
        <!-- End // -->

        <!--  Modal Create Vehicle  -->
        <createVehicleModal/>
        <!-- End // -->

        <!--  Modal Create Driver  -->
        <createDriverModal/>
        <!-- End // -->

    </div>
</template>

<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    import { mapState } from "vuex";
    const moment = require('moment');
    export default {
        name: 'CreateApplication',
        computed: {
          ...mapState("user", ["user"]),
          fas() {
            return fas;
          },
          driverNames() {
            return this.drivers.map(function (driver) {
              return driver.first_name + ' ' + driver.last_name;
            });
          },
          unSelectedDrivers() {
            return this.drivers.filter(driver => {
              return !this.declaration.drivers.includes(driver);
            });
          },
          countryNames() {
            return this.countries.map(function (country) {
              return country.name;
            });
          },
          isOwnerExpandable() {
            // For public user
            if (!this.user.data.is_officer) {
              this.collapse.owner = false;
              return true;
            }
            // For officer user
            if(this.declaration.owner.first_name){
              this.collapse.owner = false;
              return true
            }
            this.collapse.owner = true;
            return false;
          },
          // isDriverExpandable() {
          //   // For public user
          //    if (!this.user.data.is_officer) {
          //     this.collapse.driver = false;
          //     return true;
          //   }
          //   // For officer user
          //     if (this.declaration.drivers.length === 1) {
          //     if (this.declaration.drivers[0].first_name) {
          //       this.collapse.driver = false;
          //       return true;
          //     }
          //     this.collapse.driver = true;
          //   }
          //   return false;
          // },
          is_officer(){
            return this.user.data.is_officer;
          },
          offices(){
            return this.$store.getters['reference/offices'];
          },
          countries(){
            return this.$store.getters['reference/countries'];
          },
          vehicles(){
            return this.$store.getters['application/vehiclesData'];
          },
          drivers(){
            return this.$store.getters['application/driversData'];
          },
          profile_loaded(){
            return this.$store.getters['application/profileLoaded'];
          },
          allow_max_period_backup(){
            if(this.declaration.lodgement_office_date){
              this.days(); // Calculate length of stay
              return Math.floor(Math.abs((new Date(this.declaration.lodgement_office_date).getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000))-1);
            }
            return Math.floor(Math.abs((new Date().getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000))-1);
          },
          allow_max_period() {
            let selected_max_period = (this.declaration.registration_type === "IM") ? this.MAX_PERIOD : this.MAX_EXIT_PERIOD;
            let startDate = new Date();
            if(this.declaration.lodgement_office_date){
              this.days(); // Calculate length of stay
              startDate = new Date(this.declaration.lodgement_office_date);
            }

            const maxDate = new Date(startDate);
            maxDate.setDate(maxDate.getDate() + parseInt(selected_max_period));
            return maxDate;
          },
          isRequired(){
            return (driver, type) => {
              if(!driver){ return true; }

              let hasBorderPass = !!(driver.border_pass_number && driver.border_pass_date);
              let hasCompleteID = !!(driver.identity_card_number && driver.identity_card_issued_date && driver.identity_card_expired_date);
              let hasCompletePassport = !!(driver.passport_number && driver.passport_issued_date && driver.passport_expired_date);

              if(type === 'border_pass_number'){
                return true;
              }else if(type === 'border_pass_date'){
                return true;
              } else if (type === 'identity_number') {
                return !(hasBorderPass && hasCompletePassport);
              } else if (type === 'identity_issued_date') {
                return !(hasBorderPass && hasCompletePassport);
              } else if (type === 'identity_expired_date') {
                return !(hasBorderPass && hasCompletePassport);
              } else if (type === 'passport_number') {
                return !(hasBorderPass && hasCompleteID);
              } else if (type === 'passport_issued_date') {
                return !(hasBorderPass && hasCompleteID);
              } else if (type === 'passport_expired_date') {
                return !(hasBorderPass && hasCompleteID);
              }
              return false;
            }
          }
        },
        mounted() {
            //this.getCountries();
            //this.getDrivers();
            //this.getVehicles();
            //this.getOffices();
            //this.getCurrencies();
            this.$store.dispatch('application/setProfileLoaded', false);
            $(".vdp-datepicker").find("input").css("background-color", "white");
            this.MAX_PERIOD = process.env.VUE_APP_MAX_PERIOD || 30;
            this.imageBaseUrl = process.env.VUE_APP_BACKEND_API_URL + "/";
            $('[data-toggle="tooltip"]').tooltip();
            if(this.user.data.is_officer){
              this.declaration.is_owner = false;
              this.canViewOwner = true;
            }
            $('#ownerList').on("hide.bs.modal", () => {
              if(!this.isDeclarationOwnerCompleted()){
                this.declaration.is_owner = true;
                this.isOwner();
              }
            });
            this.MAX_EXIT_PERIOD = process.env.VUE_APP_MAX_EXIT_PERIOD || 365;
        },
        updated() {
            //this.days();
            $("body .readonly").removeAttr("style");
            $("body .can-editable").css("background-color", "white");
            $(".modal").on('shown.bs.modal', function (e) {
                $("body").css("overflow", "hidden");
            });
            $(".modal").on('hidden.bs.modal', function (e) {
                $("body").css("overflow", "initial");
            });
        },
        data() {
            return {
                baseURI: "",
                files: [],
                promises: [],
                //offices: [],
                currencies: [],
                companies: [],
                //drivers: [],
                //vehicles: [],
                owner: {
                    border_pass_number: '',
                    border_pass_date: ''
                },
                vehicle: {},
                declaration: {
                    registration_type: 'IM',
                    registration_number: '',
                    lodgement_office_code: '',
                    lodgement_office_name: '',
                    lodgement_office_date: '',
                    destination_office_code: '',
                    destination_office_name: '',
                    destination_office_date: '',
                    company_code: '',
                    company_name: '',
                    company_address: '',
                    is_owner: true,
                    owner: {
                        address: '',
                        //border_pass_number: '',
                        //border_pass_date: '',
                        first_name: '',
                        full_name: '',
                        gender: '',
                        last_name: '',
                        nationality: '',
                        nationality_code: '',
                        inbound_stay: 0,

                        passport_number: '',
                        passport_issued_date: '',
                        passport_expired_date: '',

                        identity_card_number: '',
                        identity_card_issued_date: '',
                        identity_card_expired_date: '',
                    },
                    security_office: '',
                    security_serial: '',
                    security_number: '',
                    security_date: '',
                    security_amount: '',
                    security_currency: '',
                    insurance_company_code: '',
                    insurance_company_name: '',
                    insurance_number: '',
                    insurance_date: '',
                    vehicles: [],
                    drivers: [],
                },

                lodgement_office: '',
                destination_office: '',
                security_office: '',
                //countries: [],
                security_errors: {
                    security_serial: false,
                    security_office: false,
                    security_number: false,
                    security_date: false
                },
                amount_is_returned: false,
                max_period: 0,
                MAX_PERIOD: 0,
                MAX_EXIT_PERIOD: 0,

                imageBaseUrl: '',
                srcImage: "",
                canViewOwner: false,
                canViewVehicle: false,
                canViewDriver: false,
                owner_is_driver: false,
                collapse:{
                    customs: false,
                    owner: false,
                    vehicle: false,
                    driver: false,
                    company: false,
                    guarantee: false,
                    other: false,
                    attachment: false,
                },
            }
        },
        watch: {
            "declaration.owner.nationality": function(val){
                if(typeof val != 'undefined' && val !== '' && val != null){
                    if(this.countries.length > 0){
                        this.declaration.owner.nationality_code = this.countries.filter(function(country){
                        return country.name === val;
                        })[0].code;
                    }
                }
            },
            "declaration.vehicles": function (val, old) {
                this.declaration.vehicles =  val;
                this.canViewVehicle = true;
            },
            "declaration.drivers": function (val, old) {
                this.declaration.drivers =  val;
                this.canViewDriver = true;
                this.owner_is_driver = this.driverIsOwner(val[0]);
            },
            lodgement_office: function(val) {
                if(val != null) {
                    this.declaration.lodgement_office_code = val.code;
                    this.declaration.lodgement_office_name = val.name;
                }
            },
            destination_office: function(val) {
                if(val != null) {
                    this.declaration.destination_office_code = val.code;
                    this.declaration.destination_office_name = val.name;
                }
            },
            security_office: function (val) {
                if(val != null) {
                    this.declaration.security_office = val.code;
                }
            },
            "declaration.is_owner": function(val){
                if(!val && this.owner_is_driver){
                    this.owner_is_driver = false;
                    this.ownerAlsoDriver();
                }
            },
            owner_is_driver: function (val) {
                if(val){
                    this.isOwnerAsDriverCompleted();
                }
            },
            vehicles(value){
              if(value.length === 1){
                  this.declaration.vehicles[0] = value[0];
                  this.canViewVehicle = true;
                }
                this.getProfile();
            },
            drivers(value){
                if(value.length === 1){
                  this.declaration.drivers[0] = value[0];
                  this.canViewVehicle = true;
                }
                this.getProfile();
            }
        },
        methods: {
            getCountries() {
                let url = this.baseURI + 'reference/countries';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.countries = response.data;
                });
            },
            validate() {
                this.$validator.validateAll();
                return this.errors.any();
            },
            ownerList() {
              $("#ownerList").modal("show");
            },
            vehicleList() {
                $("#vehicleList").modal("show");
            },
            driverList() {
                $("#driverList").modal("show");
            },
            getVehicle(uuid) {
                this.$store.state.loading.status = true;
                let url = this.baseURI + "/vehicles/" + uuid;
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.vehicle = response.data;
                    this.$store.state.loading.status = false;
                }).catch(error => {
                    this.$store.state.loading.status = false;
                });
            },
            getVehicles() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/vehicles';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.vehicles = response.data;
                    this.$nextTick(function () {
                        this.getProfile();
                        if(this.vehicles.length === 1){
                            this.declaration.vehicles[0] = this.vehicles[0];
                            this.canViewVehicle = true;
                        }
                    });
                    this.$store.state.loading.status = false;
                });
            },
            getOffices() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/reference/offices';
                GDCE_Client.requestApi("GET", url).then(response => {
                    let offices = [];
                    response.data.forEach(function(office) {
                        offices.push({name: office.name, code: office.code, full_name: office.code + " - " + office.name});
                    });
                    this.offices = offices;
                    this.$store.state.loading.status = false;
                });
            },
            viewVehicle(item){
                this.vehicle = item;
                $("#viewVehicle").modal('show');
            },
            viewOwnerDetail() {
              if(this.declaration.owner.uuid){
                window.open('/owner/' + this.declaration.owner.uuid, '_blank');
              }
            },
            viewDriverDetail() {
                if(this.user.data.uuid === this.declaration.drivers[0].uuid){
                  let route = this.$router.resolve({ name: 'Profile' });
                  window.open(route.href, '_blank');
                }
                else if(this.declaration.drivers[0].uuid){
                    window.open('/driver/' + this.declaration.drivers[0].uuid, '_blank');
                }
            },
            viewVehicleDetail() {
                if(this.declaration.vehicles[0].uuid){
                    window.open('/vehicle/' + this.declaration.vehicles[0].uuid, '_blank');
                }
            },
            getCompany() {
                if(this.declaration.company_code)
                    if(this.declaration.company_code.trim() !== ''){
                        this.$store.state.loading.status = true;
                        let url = this.baseURI+'/reference/company/' + this.declaration.company_code;
                        let address = "";
                        GDCE_Client.requestApi("GET", url).then(response => {
                            this.declaration.company_name = response.data.name;
                            if(response.data.address1)
                                address = response.data.address1;
                            if(response.data.address2)
                                address += " " + response.data.address2;
                            if(response.data.address3)
                                address += " " + response.data.address3;
                            if(response.data.address4)
                                address += " " + response.data.address4;
                            this.declaration.company_address = address.trim();
                            this.$store.state.loading.status = false;
                        }).catch(error => {
                            this.$store.state.loading.status = false;
                            this.$swal({
                                title: this.$t('label.input_information_invalid'),
                                icon: "info",
                                buttons: {
                                    yes: {
                                        text: this.$t('label.yes'),
                                        value: "Yes",
                                    }
                                }
                            }).then((value) => {
                                this.declaration.company_code = "";
                                this.declaration.company_name = "";
                                this.declaration.company_address = "";
                            });
                        });
                    }
            },
            getInsurance() {
                if(this.declaration.insurance_company_code)
                    if(this.declaration.insurance_company_code.trim() !== ''){
                        this.$store.state.loading.status = true;
                        let url = this.baseURI+'/reference/company/' + this.declaration.insurance_company_code;
                        GDCE_Client.requestApi("GET", url).then(response => {
                            this.declaration.insurance_company_name = response.data.name;
                            this.declaration.insurance_number = response.data.insurance_number;
                            // this.declaration.insurance_date = this.renderDate(response.data.valid_from);
                            this.$store.state.loading.status = false;
                        }).catch(error => {
                            this.$store.state.loading.status = false;
                            this.$swal({
                                title: this.$t('label.input_information_invalid'),
                                icon: "info",
                                buttons: {
                                    yes: {
                                        text: this.$t('label.yes'),
                                        value: "Yes",
                                    }
                                }
                            }).then((value) => {
                                this.declaration.insurance_company_code = "";
                                this.declaration.insurance_company_name = "";
                                this.declaration.insurance_number = "";
                                this.declaration.insurance_date = "";
                            });
                        });
                    }
            },
            getSecurityAmount(data) {
                if((this.declaration.security_office !== "" && this.declaration.security_office !== null)
                    && (this.declaration.security_serial !== "" && this.declaration.security_serial !== null)
                    && (this.declaration.security_number !== "" && this.declaration.security_number !== null)
                    && (this.declaration.security_date !== "" && this.declaration.security_date !== null)){

                    this.$store.state.loading.status = true;
                    let data = {
                        security_office: this.declaration.security_office,
                        security_serial: this.declaration.security_serial,
                        security_number: this.declaration.security_number,
                        security_date: this.renderDate(this.declaration.security_date)
                    };
                    let url = this.baseURI+'/reference/deposit';
                    GDCE_Client.requestApi("POST", url, data).then(response => {
                        if(response.status) {
                            this.declaration.security_amount = response.data.amount;
                            this.declaration.security_currency = response.data.currency;

                            this.security_errors.security_office = false;
                            this.security_errors.security_serial = false;
                            this.security_errors.security_number = false;
                            this.security_errors.security_date = false;

                            if(response.data.is_returned === "on")
                                this.amount_is_returned = true;
                            else
                                this.amount_is_returned = false;
                        } else {
                            this.declaration.security_amount = "";
                            this.declaration.security_currency = "";
                            this.amount_is_returned = false;
                        }
                        this.$store.state.loading.status = false;
                    }).catch(error => {
                        this.declaration.security_amount = "";
                        this.declaration.security_currency = "";

                        this.security_errors.security_office = true;
                        this.security_errors.security_serial = true;
                        this.security_errors.security_number = true;
                        this.security_errors.security_date = true;
                        this.amount_is_returned = false;
                        this.$store.state.loading.status = false;

                        this.$swal({
                            title: this.$t('label.guarantee_information_invalid'),
                            icon: "info",
                            buttons: {
                                yes: {
                                    text: this.$t('label.yes'),
                                    value: "Yes",
                                }
                            }
                        }).then((value) => {
                            this.declaration.security_office = "";
                            this.declaration.security_serial = "";
                            this.declaration.security_number = "";
                            this.declaration.security_date = "";
                            this.declaration.security_amount = "";
                            this.declaration.security_currency = "";
                            $("input[name='security_office']").focus();

                            this.security_errors.security_office = false;
                            this.security_errors.security_serial = false;
                            this.security_errors.security_number = false;
                            this.security_errors.security_date = false;
                            this.amount_is_returned = false;
                        });
                    });
                } else {
                    this.declaration.security_amount = "";
                    this.declaration.security_currency = "";
                }
            },
            getDrivers () {
                this.$store.state.loading.status = true;
                let url = this.baseURI + 'drivers';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.drivers = response.data;
                    this.$nextTick(function () {
                        this.getProfile();
                        if(this.drivers.length===1){
                            this.declaration.drivers[0] = this.drivers[0];
                            this.canViewDriver = true;
                        }
                    });
                    this.$store.state.loading.status = false;
                });
            },
            isOwner() {
                if(this.declaration.is_owner){
                    if(this.owner.first_name == null || this.owner.last_name == null
                        || this.owner.nationality == null || this.owner.nationality_code == null
                        || this.owner.identity_card_number == null || this.owner.identity_card_issued_date == null
                        || this.owner.identity_card_expired_date == null || this.owner.address == null)
                    {
                        swal({
                            title: this.$t('message.not_update_profile'),
                            text: this.$t('message.instruction_info'),
                            icon: "warning",
                            buttons: {
                                OK: {
                                    text: this.$t('label.ok'),
                                    value: "OK"
                                }
                            }
                        })
                        .then((value) => {
                            switch (value) {
                                case "OK":
                                    this.$router.push({ name: 'SetupProfile'});
                                    break;
                                default:
                                    this.$router.push({ name: 'SetupProfile'});
                            }
                        });
                    } else {
                        if(!this.drivers || this.drivers.length < 1 && !this.user.data.is_officer) {
                            swal({
                                title: this.$t('message.no_driver'),
                                text: this.$t('message.instruction_info'),
                                icon: "warning",
                                buttons: {
                                    OK: {
                                        text: this.$t('label.ok'),
                                        value: "OK"
                                    }
                                }
                            })
                            .then((value) => {
                                switch (value) {
                                    case "OK":
                                        this.$router.push({ name: 'SetupProfile'});
                                        break;
                                    default:
                                        this.$router.push({ name: 'SetupProfile'});
                                }
                            });
                        }else if(!this.vehicles || this.vehicles.length < 1) {
                            swal({
                                title: this.$t('message.no_vehicle'),
                                text: this.$t('message.instruction_info'),
                                icon: "warning",
                                buttons: {
                                    OK: {
                                        text: this.$t('label.ok'),
                                        value: "OK"
                                    }
                                }
                            })
                            .then((value) => {
                                switch (value) {
                                    case "OK":
                                        this.$router.push({ name: 'SetupProfile'});
                                        break;
                                    default:
                                        this.$router.push({ name: 'SetupProfile'});
                                }
                            });
                        }
                        this.declaration.owner = this.owner;
                        typeof this.declaration.owner.border_pass_number == 'undefined' ? this.declaration.owner.border_pass_number = '' : this.declaration.owner.border_pass_number;
                        typeof this.declaration.owner.border_pass_date == 'undefined' ? this.declaration.owner.border_pass_date = null : this.declaration.owner.border_pass_date;
                        typeof this.declaration.owner.identity_card_number == 'undefined' ? this.declaration.owner.identity_card_number = '' : this.declaration.owner.identity_card_number;
                        typeof this.declaration.owner.identity_card_issued_date == 'undefined' ? this.declaration.owner.identity_card_issued_date = null : this.declaration.owner.identity_card_issued_date;
                        typeof this.declaration.owner.identity_card_expired_date == 'undefined' ? this.declaration.owner.identity_card_expired_date = null : this.declaration.owner.identity_card_expired_date;
                    }
                }else{
                    if(!this.is_officer){
                      $("#ownerList").modal("show");
                    }
                    this.declaration.owner = {
                        passport_number: '',
                        nationality: '',
                        border_pass_number : '',
                        border_pass_date : null,
                        identity_card_number : '',
                        identity_card_issued_date : '',
                        identity_card_expired_date : '',
                    };
                }
            },
            isOwnerAsDriverCompleted(){
                if(this.owner.passport_expired_date == null || this.owner.passport_issued_date == null
                    || this.owner.passport_image_front == null || this.owner.passport_image_back == null
                    || this.owner.passport_number == null || !this.owner.driver_uuid)
                {
                    swal({
                        title: this.$t('message.not_update_passport'),
                        text: this.$t('message.instruction_info'),
                        icon: "warning",
                        buttons: {
                            OK: {
                                text: this.$t('label.ok'),
                                value: "OK"
                            },
                            ClOSE: {
                                text: this.$t('label.close'),
                                value: "ClOSE"
                            }
                        }
                    })
                    .then((value) => {
                        switch (value) {
                            case "OK":
                                this.$router.push({ name: 'Profile'});
                                break;
                            default:
                                this.owner_is_driver = false;
                                this.declaration.drivers[0] = {
                                  border_pass_date: null,
                                  border_pass_number: ""
                                }
                        }
                    });
                }
            },
            getCurrencies() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/reference/currencies';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.currencies = response.data;
                    this.$store.state.loading.status = false;
                }).catch(error => {
                    this.$store.state.loading.status = false;
                });
            },
            getProfile () {
              if(this.profile_loaded){
                return;
              }
              this.$store.dispatch('application/setProfileLoaded', true);
              this.$store.state.loading.status = true;
                let url = this.baseURI + 'profile';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.owner = response.data;
                    this.$nextTick(function () {
                        this.isOwner();
                    });
                    this.$store.state.loading.status = false;
                });
            },
            changeEntryDate(dateChange) {
                this.declaration.lodgement_office_date = new Date(dateChange).getTime();
                this.declaration.destination_office_date = '';
            },
            changeExitDate(dateChange) {
                this.declaration.destination_office_date = new Date(dateChange).getTime();
            },
            days_backup() {
                if(
                    (this.declaration.lodgement_office_date !== "" || this.declaration.lodgement_office_date != null) &&
                    (this.declaration.destination_office_date !== "" || this.declaration.destination_office_date != null))
                {
                    let oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
                    let entry_date = new Date(this.declaration.lodgement_office_date);
                    let exit_date = new Date(this.declaration.destination_office_date);
                    this.max_period = Math.floor(Math.abs((entry_date.getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000))-1);
                    let inbound_stay = Math.floor(Math.abs((entry_date.getTime() - exit_date.getTime())/(oneDay))+1);
                    if(!isNaN(inbound_stay)) {
                        this.declaration.owner.inbound_stay = inbound_stay;
                    }
                }
            },
            store(e) {
                this.$validator.validate()
                    .then(result => {
                        if (!result) {
                            e.preventDefault();
                            this.ifCustomsRegistrationCompleted();
                        }else{
                            if(this.declaration.vehicles.length >= 1 && this.isDriverSelected() && this.isOwnerSelected()) {
                              this.$store.state.loading.status = true;
                              let url = this.baseURI + 'applications';
                              GDCE_Client.requestApi("POST", url, this.declaration).then(response => {
                                this.$store.state.loading.status = false;
                                if (response.status) {
                                  var app_uuid = response.data;
                                  if (this.files.length > 0) {
                                    let formData = new FormData();
                                    for (var i = 0; i < this.files.length; i++) {
                                      let file = this.files[i];
                                      formData.append('files' + i, file);
                                    }
                                    const config = {
                                      headers: {"Content-Type": "multipart/form-data"}
                                    };
                                    url = this.baseURI + "/applications/" + app_uuid + "/upload";
                                    GDCE_Client.requestApi("POST", url, formData, config).then(respone => {
                                      if (respone.status) {
                                        this.$router.push({name: 'ViewApplication', params: {uuid: app_uuid}});
                                      }
                                    }).catch(error => {
                                      this.$store.state.loading.status = false;
                                    });
                                  } else {
                                    this.$router.push({name: 'ViewApplication', params: {uuid: app_uuid}});
                                  }
                                } else {
                                  this.$swal({
                                    title: this.$t('message.already_declaration'),
                                    icon: "info",
                                    text: response.message,
                                    buttons: {
                                      close: this.$t('label.close'),
                                    }
                                  })
                                }
                              }).catch(() => {
                                this.$store.state.loading.status = false;
                              });
                            } else if(!this.isOwnerSelected()){
                                this.ownerList();
                            } else if(this.declaration.vehicles.length < 1) {
                                this.vehicleList();
                            } else if(!this.isDriverSelected()) {
                                this.driverList();
                            }
                        }
                    }
                );
            },
            clearLodgmentOffice(data) {
                if(data === null) {
                    this.declaration.lodgement_office_code = "";
                    this.declaration.lodgement_office_name = "";
                }
            },
            clearDestinationOffice(data) {
                if(data === null) {
                    this.declaration.destination_office_code = "";
                    this.declaration.destination_office_name = "";
                }
            },
            clearSecurityOffice(data) {
                if(data === null) {
                    this.declaration.security_office = "";
                }
            },
            viewDriver(driver){
                if(driver){
                    window.open('/driver/' + driver.uuid, '_blank');
                }
            },
            removeVehicle(index) {
                this.declaration.vehicles.splice(index, 1);
                this.declaration.drivers.splice(index, 1);
            },
            companyCodeKeyDown(e) {
                if(e.keyCode === 46 || e.keyCode === 8) {
                    this.declaration.company_name = "";
                    this.declaration.company_address = "";
                    this.$store.state.loading.status = false;
                } else if(e.keyCode === 13) {
                    this.getCompany();
                }
            },
            renderDate(myDate){
                return myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate();
            },
            handleFilesUpload(){
                let uploadedFiles = this.$refs.attachment.files;
                for( var i = 0; i < uploadedFiles.length; i++ ){
                    if(this.hasExtension(uploadedFiles[i].name, ['.jpeg','.png','.jpg','.pdf'])){
                        if(uploadedFiles[i].size < (1024 * 1024) * 10){
                            this.files.push( uploadedFiles[i] );
                        }
                    }
                }
            },
            hasExtension(file_name, exts) {
                var extention = file_name.substring(file_name.length - 4,file_name.length);
                for(var i = 0; i < exts.length; i++){
                    if(extention === exts[i]){
                        return true;
                    }
                }
            },
            removeFile(key){
                this.files.splice( key, 1 );
            },
            driverIsOwner(owner){
                return this.owner.first_name === owner.first_name &&
                    this.owner.last_name === owner.last_name &&
                    this.owner.nationality_code === owner.nationality_code &&
                    this.owner.identity_card_number === owner.identity_card_number;
            },
            ownerAlsoDriver(){
                if(this.owner_is_driver || this.user.data.is_officer){
                    if(!this.isDeclarationOwnerCompleted()){
                      this.pleaseCompleteOwnerModal();
                      return;
                    }
                    this.declaration.drivers[0] = this.declaration.owner;
                    this.removeError({name: 'driver_first_name', scope: null});
                    this.removeError({name: 'driver_last_name', scope: null});
                    this.removeError({name: 'driver_gender', scope: null});
                    this.removeError({name: 'driver_passport_number', scope: null});
                    this.removeError({name: 'driver_passport_issued_date', scope: null});
                    this.removeError({name: 'driver_passport_expired_date', scope: null});
                    this.removeError({name: 'driver_address_in_cambodia', scope: null});
                }else{
                    if(this.drivers.length > 1){
                        this.declaration.drivers[0] = {
                            border_pass_number : '',
                            border_pass_date : null,
                            identity_card_number: '',
                            identity_card_issued_date: '',
                            identity_card_expired_date: '',
                        };
                    }
                }
            },
            removeError(matchOptions){
                const field = this.$validator.fields.find(matchOptions);
                field.reset();
                this.$validator.errors.remove(field.name, field.scope);
            },
            driverOfficeChange(val){
                if(typeof val != 'undefined' && val !== '' && val != null){
                    if(this.countries.length > 0){
                        this.declaration.drivers[0].nationality_code = this.countries.filter(function(country){
                        return country.name === val;
                        })[0].code;
                    }
                }
            },
            showImage(src) {
                if(src.name.includes(this.declaration.uuid)){
                    window.open( this.imageBaseUrl + src.name);
                }else{
                    window.open(URL.createObjectURL(src));
                }
            },
            isDeclarationOwnerCompleted(){
              return this.declaration.owner.last_name &&
                  this.declaration.owner.first_name &&
                  this.declaration.owner.nationality &&
                  this.declaration.owner.nationality_code &&
                  this.declaration.owner.gender &&
                  this.declaration.owner.identity_card_number;
            },
            pleaseCompleteOwnerModal(){
              this.$swal({
                title: this.$t('message.please_complete_declaration_owner_first'),
                icon: "info",
                buttons: {
                  close: this.$t('label.close'),
                }
              }).then(()=>{
                this.owner_is_driver = false;
                document.getElementById("owner-info").scrollIntoView();
              });
            },
            isOwnerSelected(){
              return (this.declaration.owner.first_name &&
                     this.declaration.owner.last_name &&
                     this.declaration.owner.nationality);
            },
            isDriverSelected(){
              if(this.declaration.drivers.length > 0){
                const driver = this.declaration.drivers[0];
                return (driver.first_name &&
                       driver.last_name &&
                       driver.nationality);
              }
              return false;
            },
            ifCustomsRegistrationCompleted(){
              if(!this.declaration.lodgement_office_code ||
                 !this.declaration.lodgement_office_date ||
                 !this.declaration.destination_office_code ||
                 !this.declaration.destination_office_date)
              {
                this.goIntoView('customs-info');
              }
            },
            goIntoView(id){
              document.getElementById(id).scrollIntoView();
            },
            days() {
              if(this.declaration.lodgement_office_date && this.declaration.destination_office_date)
              {
                let entry_date   = moment(this.declaration.lodgement_office_date);
                let exit_date    = moment(this.declaration.destination_office_date);
                let inbound_stay = (exit_date.diff(entry_date, 'days') + 1);
                if(!isNaN(inbound_stay)) {
                  this.declaration.owner.inbound_stay = inbound_stay;
                }
              }else{
                this.declaration.owner.inbound_stay = null;
              }
            }
        }
    }
</script>

<style lang="scss" scoped>
    h3.custom-card-title svg{
        font-size: 22px !important;
    }
    .custom-card-title{
        color: #205670;
        text-transform: none !important;
    }

    .error-border {
        border: 1px solid rgb(200, 0, 0);
        border-radius: 4px;
    }
    .pointer {
        cursor: pointer;
    }
    .table-no-margin-padding tr td {
        padding: 2px 5px !important;
        margin: 0px !important;
    }
    .modal-open {
        overflow: scroll;
    }

	/* 100% Image Width on Smaller Screens */
	@media only screen and (max-width: 700px) {
		.modal-content {
			width: 100%;
		}
	}
    label.required {
		&::after {
			content: " *";
			color: red;
		}
	}
  .btn:disabled{
    cursor: default;
  }
</style>
